<template>
    <div class="vip">
        <div class="vipCenter">
            <div class="option">
                <div class="title">基本信息</div>
                <div class="user">
                    <div class="img">
                        <!-- <img src="../../../assets/logo.png" /> -->
                        <img :src="$global.Local + $global.webData.headImg" v-if="$global.webData.headImg"/>
                        <img src="../../../assets/logo.png" v-else/>
                    </div>
                    <div class="informat">
                        <div class="name">
                          <div v-show="$global.webData.type != 1 && $global.webData.type != 2">
                            {{$global.webData.name}}
                             <span @click="handlCheckAuthen">去认证</span>
                          </div>
<!--                            <span v-show="$store.store.state.userData.passStatus == 0 && $global.webData.type == 1">审核中</span>-->
<!--                            <span v-show="$store.store.state.userData.passStatus == 0 && $global.webData.type == 2 && $global.webData.authMoney">审核中</span>-->
                            <!--               <span v-show="passStatus == 3 && $store.store.state.userData.passStatus == 0">审核中</span> -->
<!--                            <span @click="handlCheckAuthen"-->
<!--                                  v-show="$global.webData.type == 1 && !$global.webData.farenCode && $store.store.state.userData.passStatus == 1">企业认证</span>-->
                            <!-- <span @click="handlCheckAuthen"
                                  v-show="$global.webData.farenCode && !$global.webData.authMoney && passStatus == 2">对公认证</span> -->
                          <div class="top">
                            <div class="top" v-if="$store.store.state.userData.type == 1">
                              {{$global.webData.name}}
                              <span v-if="$store.store.state.userData.passStatus == 0">审核中</span>
                              <span v-if="$store.store.state.userData.passStatus == 1" @click="handlCheckAuthen">个人已认证，点击企业认证</span>
                              <span v-if="$store.store.state.userData.passStatus == 2">审核未通过，重新认证</span>
                            </div>
                            <div class="top" v-if="$store.store.state.userData.type == 2">
                              {{$global.webData.name}}
                              <span v-if="$store.store.state.userData.passStatus == 0">审核中</span>
                              <span v-if="$store.store.state.userData.passStatus == 1">已认证</span>
                              <span v-if="$store.store.state.userData.passStatus == 2" @click="handlCheckAuthen">审核未通过，重新认证</span>
                            </div>
                          </div>
                        </div>
                        <div class="email">邮箱号：{{$global.webData.email}}</div>
                        <div class="phone">手机号：{{$global.webData.phone}}</div>
                    </div>
                </div>
            </div>
            <div class="actent">
                <div class="title">产品/服务</div>
                <div class="surplusDate">
                    <td v-if="cert.uselimitOrtimelimt">证书：{{cert.uselimitOrtimelimt}}</td>
                    <td v-else-if="cert.timeLimit">证书有效期：{{cert.timeLimit}}天</td>
                    <td v-else="cert.useLimit">证书有效期：{{cert.useLimit}}次</td>
                    <!-- <span @click="handlBuyCertTable" v-show="cert.length < 5">购买记录</span> -->
                </div>
                <div class="btn" @click="handlBuyCert">续次</div>
            </div>
        </div>
        <div class="vipBasic">
            <div class="title">基础设置</div>
            <div class="vip_function">
                <div class="for" v-for="(item,index) in funData" :key="index" @click="handlCheckFun(index)">
                    {{item.title}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                passStatus: 0,
                cert: '',
                funData: [{
                    title: '印章申请'
                },
                    {
                        title: '印章管理'
                    },
                    {
                        title: '签章查验'
                    },
                    {
                        title: '我的订单'
                    },
                    {
                        title: '关于我们'
                    },
                    {
                        title: '修改密码'
                    },
                    {
                        title: '注销账户'
                    },
                    {
                        title: '退出登录'
                    },

                ]
            }
        },
        created() {
            let _this = this;
            let param = new FormData();
            _this.passStatus = localStorage.getItem('passState');
            param.append('token', _this.$global.token);
            _this.api.getStatistics(param).then(res => {
                _this.cert = res.data;
            })
        },
        mounted() {
            // console.log(this.$global.webData, "我我我")
        },
        methods: {
            handlCheckFun(index) {
                if (!this.$global.webData.type) {
                    this.$message.info('请先进行认证');
                    this.$router.push('authen');
                    return
                }
                if (index == 0) {
                    this.$router.push({
                        name: 'sealList'
                    })
                } else if (index == 1) {
                    this.$router.push({
                        name: 'sealListZhang'
                    })
                } else if (index == 2) {
                    this.$router.push({
                        // name: 'signInsp'
                        name:'youKe'
                    })
                } else if (index == 3) {
                    this.$router.push({
                        name: 'myOrder'
                    })
                } else if (index == 4) {
                    this.$router.push({
                        name: 'aboutUs'
                    })
                } else if (index == 5) {
                    this.$router.push({
                        name: 'changePassWord'
                    })
                } else if (index == 6) {
                    this.logoff();
                } else if (index == 7) {
                    this.logout();
                }

            },
            logoff() {
                this.$confirm('此操作将摧毁账号信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    let _this = this;
                    let param = new FormData();
                    param.append('token', _this.$global.token);
                    _this.api.cancelMember(param).then(res => {
                        console.log(res);
                        _this.$message.success('账号已注销');
                        _this.$router.push({
                            path: '/'
                        })
                        var storage = window.localStorage;
                        storage.clear();
                        location.reload();
                    })
                }).catch(() => {
                });
            },
            logout() {
                this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let _this = this;
                    let param = new FormData();
                    param.append('token', _this.$global.token);
                    _this.api.logout(param).then(res => {
                        console.log(res);
                        _this.$message.success('退出登录');
                        _this.$router.push({
                            path: '/'
                        })
                        localStorage.removeItem('user_token');
                        localStorage.removeItem('user_data');
                        localStorage.removeItem('login');
                        localStorage.removeItem('lastTime');
                        location.reload();
                    })
                }).catch(() => {
                });
            },
            handlBuyCert() {
                if (!this.$global.webData.type) {
                    this.$message.info('请先进行认证');
                    this.$router.push('authen');
                    return
                }
                this.$router.push({
                    name: 'buyCert',
                    params: {
                        state: 0
                    }
                });
            },
            handlBuyCertTable() {
                this.$router.push('certList');
            },
            handlCheckAuthen() {
                this.$router.push('authen');
            }

        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .vip {
        width: @a;
        height: auto;
        margin-left: 4%;

        .vipCenter {
            width: 1073px;
            height: auto;
            display: @flex;

            .option {
                width: 614px;
                height: 172px;

                .title {
                    width: @a;
                    height: 24px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .user {
                    width: @a;
                    height: @a;
                    display: @flex;
                    margin-top: 28px;

                    .img {
                        width: 120px;
                        height: 120px;
                        border-radius: 50px;
                        overflow: hidden;

                        img {
                            width: @a;
                            height: @a;
                            object-fit: cover;
                        }
                    }

                    .informat {
                        margin-left: 29px;
                        width: calc(@a - 162px);
                        height: @a;

                        .name {
                            width: @a;
                            height: 30px;
                            line-height: 30px;
                            font-family: MicrosoftYaHei-Bold;
                            font-size: 24px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 1px;
                            color: #333333;
                            margin-top: 14px;

                            span {
                                padding: 3px 6px;
                                background-color: #f2f2f2;
                                border-radius: 10px;
                                border: solid 1px #aaaaaa;
                                font-size: 18px;
                                margin-left: 20px;
                                cursor: pointer;
                            }
                        }

                        .email {
                            width: @a;
                            height: 24px;
                            line-height: 24px;
                            font-family: MicrosoftYaHei;
                            font-size: 18px;
                            font-weight: normal;
                            font-stretch: normal;
                            line-height: 30px;
                            letter-spacing: 0px;
                            color: #333333;
                            margin-top: 22px;
                        }

                        .phone {
                            width: @a;
                            height: 24px;
                            line-height: 24px;
                            font-family: MicrosoftYaHei;
                            font-size: 18px;
                            font-weight: normal;
                            font-stretch: normal;
                            line-height: 30px;
                            letter-spacing: 0px;
                            color: #333333;
                        }
                    }
                }

            }

            .actent {
                width: 460px;
                height: 172px;

                .title {
                    width: @a;
                    height: 24px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .surplusDate {
                    width: 250px;
                    height: 18px;
                    font-family: MicrosoftYaHei;
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #333333;
                    margin-top: 47px;
                    display: flex;

                    span {
                        font-family: MicrosoftYaHei;
                        font-size: 18px;
                        font-weight: normal;
                        letter-spacing: 0px;
                        color: #1e6eee;
                        margin-left: 20px;
                        cursor: pointer;
                    }
                }

                .btn {
                    width: 250px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    letter-spacing: 1px;
                    color: #fff;
                    font-size: 24px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    margin-top: 27px;
                    cursor: pointer;
                }
            }
        }

        .vipBasic {
            width: auto;
            height: 312px;
            margin-top: 28px;

            .title {
                width: auto;
                height: 24px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .vip_function {
                width: 1073px;
                height: auto;
                overflow: hidden;
                zoom: 1;
                margin-top: 28px;

                .for:hover {
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                }

                .for:nth-child(4n+1) {
                    margin-left: 0;
                }

                .for {
                    width: 245px;
                    height: 120px;
                    background-color: #fff;
                    border-radius: 20px;
                    border: solid 1px #aaaaaa;
                    letter-spacing: 1px;
                    color: #333333;
                    font-size: 24px;
                    line-height: 120px;
                    text-align: center;
                    float: left;
                    cursor: pointer;
                    margin: 20px 0 0 30px;
                }

                .forActive {
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/vip/vipCenter.vue